export default {
  init() {

    jQuery(document).ready(function() 
    {
      let alreadyTriggered = false;

      jQuery(window).scroll(function() 
      {
        if (jQuery(document).scrollTop() > 150 && !alreadyTriggered) {
          jQuery("#subscribe-us-modal").modal("show");
          alreadyTriggered = true;
        }
      });
    });


    jQuery( ".animalSelector" ).click(function() {

        let option = jQuery(".hidden", this);
        
        if (!option)
        {
            return;
        }

        if (option.is(":checked"))
        {
            option.removeAttr("checked");
            jQuery(this).removeClass("selected");
        } else {
            jQuery( ".animalSelector" ).each((index, el) => {
                jQuery(el).removeClass("selected");
                jQuery(".hidden", el).attr('checked', false);
            });
            jQuery(this).addClass("selected");
            option.attr('checked', 'checked');
        }
        
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js